require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-dexter-lesaca.json") })
        }
      }, "path---blog-author-dexter-lesaca");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-dexter-lesaca!./.cache/json/blog-author-dexter-lesaca.json
// module id = 625
// module chunks = 231608221292675